module.exports = "https://static.wanderu.com/static/media/explorebywanderu-social.4849f744.png";